import { AuthState } from '../../redux/modules/auth/reducer';
import { ConfigState } from '../../redux/modules/config/reducer';
import queryString from 'query-string';

export const generateLink = ({
  activeAccountId,
  activeProjectId,
  activeCohortId,
  url,
}: {
  activeAccountId: string;
  activeProjectId?: string;
  activeCohortId?: string;
  url: string;
}) => {
  const params = {
    account: activeAccountId,
    ...(activeProjectId && { projectId: activeProjectId }),
    ...(activeCohortId && { cohortId: activeCohortId }),
    ...queryString.parse(window.location.search),
  };

  return `${url.split(/[?#]/)[0]}?${queryString.stringify(params)}${
    window.location.hash
  }`;
};

export const isCustomClientInUse = (config: ConfigState, auth: AuthState) => {
  return auth.oauthClientId !== config.oauthClientId;
};
